// общие константы приложения
export const AppConstant = {
    /**
     * Время повторного запроса, например проверки статусов
     */
    TIMEOUT_WAITER_REQUEST: 5000,
    /**
     * Время задержки для запроса debounce
     */
    TIMEOUT_DEBOUNCE: 1000,
    /**
     * Десктоп (css variable XL)
     */
    DESKTOP_WIDTH: 1200,
    /**
     * Большие планшеты и ноутбуки (css variable LG)
     */
    NOTEBOOK_WIDTH: 992,
    /**
     * Планшеты и телефоны (css variable MD)
     */
    TABLET_WIDTH: 768,
    /**
     * Маленькие телефоны (css variable SM)
     */
    MOBILE_WIDTH: 576,
};
